declare const window: any;

export function getApiHostname() {
    return new URL(getApiUrl()).hostname;
}

export function getApiUrl() {
    return window.location.protocol + '//' + window.location.host + '/backend';
}

export function getSentryDSN() {
    return window.appConfig.services.sentry.dsn;
}

export function getSocketUrl() {
    return (window.location.protocol === 'http:' ? 'ws://' : 'wss://') + window.location.host + window.appConfig.socket.v2_url;
}

export function initGtm(w:any,d:any,s:any,l:any,i:any){
    w[l]=w[l]||[];
    w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
    var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;
    j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
    f.parentNode.insertBefore(j,f);
}

export function addThemeColor(hexColor:string) {
    const meta = document.createElement('meta');
    meta.name = 'theme-color';
    meta.content = hexColor;
    document.head.appendChild(meta);
}